module.exports = __webpack_public_path__ + "static/media/fallback.6bf81c74.svg";